import React, { useContext, useState, useEffect } from "react"
import { Outlet, useSearchParams } from "react-router-dom"
import { UserCtx } from "../../context/userContext"
import { useAuthenticatedUser } from "../../hooks/useAuthenticatedUser"
import SessionTimeOutModal from "./SessionTimeOutModal"

const PrivateRouteUser = () => {
  const { user } = useContext(UserCtx)
  const authenticatedUser = useAuthenticatedUser(user)
  const [searchParams] = useSearchParams()
  const [showSessionExpiredDialog, setShowSessionExpiredDialog] = useState(false)

  useEffect(() => {
    if (!authenticatedUser) {
      setShowSessionExpiredDialog(true)
    }
  }, [authenticatedUser])

  const keys = Array.from(searchParams.keys())
  const params: any = {}
  keys.forEach((key) => {
    params[key] = searchParams.get(key)
  })

  return (
    <>
      {authenticatedUser && <Outlet />}

      <SessionTimeOutModal
        isOpen={showSessionExpiredDialog}
        onClose={() => setShowSessionExpiredDialog(false)}
      />
    </>
  )
}

export default PrivateRouteUser